// // // import axios from "axios";
// // // import { BASE_URL } from "./URL.js";

// // // const axiosInstance = axios.create({
// // //   baseURL: BASE_URL,
// // // });

// // // axiosInstance.interceptors.request.use((config) => {
// // //   const token = localStorage.getItem("__inventory_sys_auth_token_5f9dA72xQp__");
// // //   if (token) {
// // //     config.headers.Authorization = `Bearer ${token}`;
// // //   }
// // //   return config;
// // // });

// // // export default axiosInstance;




import axios from "axios";
import { BASE_URL } from "./URL.js";
import Swal from "sweetalert2";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Request Interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("__inventory_sys_auth_token_5f9dA72xQp__");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("__inventory_sys_auth_token_5f9dA72xQp__");
      
      Swal.fire({
        icon: "warning",
        title: "انتهت الجلسة",
 
        text: "الرجاء تسجيل الدخول مرة أخرى",
        timer: 4000,
        timerProgressBar: true,
        confirmButtonText: "حسناً",
      }).then(() => {
        window.location.href = "/login";
      });
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;